import customFetcher from "./customFetch";
import {Book} from "../models/Book";
import {BookAnalysis} from "../models/BookAnalysis";
import {PaginatedResponse} from "./paginatedResponse";
export type PaginatedBookResponse = PaginatedResponse<Book>;

class BookService {
    private baseUrl: string = 'http://protekids-env-1.eba-rwb3patd.us-east-1.elasticbeanstalk.com';

    async getBooks(title?: string): Promise<PaginatedBookResponse> {
        if (title){
            return customFetcher<PaginatedBookResponse>(`${this.baseUrl}/book?title=${encodeURI(title)}`);
        }
        return customFetcher<PaginatedBookResponse>(`${this.baseUrl}/book`);
    }

    async getBookById(bookId: number): Promise<Book> {
        return customFetcher<Book>(`${this.baseUrl}/book/${bookId}`);
    }

    async createBook(newBook: Partial<Book>): Promise<Book> {
        return customFetcher<Book>(`${this.baseUrl}/book`, {
            method: 'POST',
            body: JSON.stringify(newBook),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    async updateBook(bookId: number, updatedBook: Partial<Book>): Promise<Book> {
        return customFetcher<Book>(`${this.baseUrl}/books/${bookId}`, {
            method: 'PUT',
            body: JSON.stringify(updatedBook),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    async deleteBook(bookId: number): Promise<void> {
        await customFetcher<void>(`${this.baseUrl}/books/${bookId}`, {
            method: 'DELETE',
        });
    }

    async getBookAnalysis(bookId: number): Promise<BookAnalysis> {
        const analysisResult = await customFetcher<BookAnalysis>(`${this.baseUrl}/book/content-analyser/by-book-id/${bookId}`);
        return analysisResult;
    }
    
}
export default BookService;
